import { createRouter, createWebHistory } from 'vue-router'
// import HomeView from '../views/HomeView.vue'

const routes = [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: HomeView
  // },
  {
    path: '/ev',
    name: 'evaluation',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/evaluation.vue')
  },
  {
    path: '/pb',
    name: 'pb',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/pb.vue')
  },
  {
    path: '/medical-description',
    name: 'medical-description',
    component: () => import(/* webpackChunkName: "about" */ '../views/medical-description.vue')
  },
  {
    path: '/share-role',
    name: 'share-role',
    component: () => import(/* webpackChunkName: "about" */ '../views/share-role.vue')
  },
  {
    path: '/shop-list',
    name: 'shop-list',
    component: () => import(/* webpackChunkName: "about" */ '../views/shop-list.vue')
  },
  {
    path: '/channel/user',
    name: 'channelUser',
    component: () => import(/* webpackChunkName: "about" */ '../views/channel/user.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
